module.exports = __webpack_public_path__ + "img/39.9.TU.f315f0ac.png";